import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useSiteTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
